var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-container"},[_c('transition-group',{staticClass:"slider",attrs:{"tag":"div","name":"slide"}},_vm._l(([_vm.currentIndex]),function(number){return _c('div',{key:number,style:('background-image: url(' +
        _vm.slides[Math.abs(_vm.currentIndex) % _vm.slides.length] +
        ')')})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }